import React, { PureComponent } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;
`;

const FormulaBlock = styled.div`
  background: #E5F4E9;
  border: 1px solid #D5D9DD;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 76px 59px;
  font-family: 'Mukta Vaani';
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  margin-top: 12px;
`;

const FormulaLeftPart = styled.div`
  background: #2DA548;
  border-radius: 8px;
  padding: 16px;
  color: #fff;
  text-align: center;
  margin-right: 24px;
`;

const EqualitySign = styled.div`
  width: 16px;
  height: 7px;
  position: relative;

  &:before, &:after {
    display: block;
    content: '';
    position: absolute;
    width: 100%;
    height: 1.5px;
    background: rgba(0, 27, 59, 0.94);
    border-radius: 100px;
  }

  &:before {
    top: 0;
  }

  &:after {
    bottom: 0;
  }
`;

const FormulaRightPart = styled.div`
  display: flex;
  flex-direction: column;
  width: 324px;
  margin-left: 24px;
  text-align: center;
  color: rgba(0, 27, 59, 0.94);

  b {
    color: #EC5E59;
  }
`;

const FormulaDivider = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(0, 27, 59, 0.94);
  margin: 12px 0;
`;

class NewMetricEPS extends PureComponent {

  render() {
    return (
      <Wrapper>
        <Container>
          <Text1>What to expect</Text1>
          <Text2>New Scoring Metric: Earnings Per Share (EPS)</Text2>
          <Text3>
            <p>Investors will continue to evaluate the return on their investment using net profits as a measure of that return.  Therefore, make sure your company makes a profit. </p>
          </Text3>
          <FormulaBlock>
            <FormulaLeftPart>
              <p>Earnings Per Share</p>
              <p>(EPS)</p>
            </FormulaLeftPart>
            <EqualitySign></EqualitySign>
            <FormulaRightPart>
              <p>Net Profits</p>
              <FormulaDivider></FormulaDivider>
              <p><b>*</b> Average Total Shares Outstanding</p>
            </FormulaRightPart>
          </FormulaBlock>
          <Text3>
            <p>Earnings Per Share (EPS) is one of the profit driven metrics that will be used to measure your performance this round. <a href="https://www.investopedia.com/terms/e/eps.asp#:~:text=Earnings per share (EPS) is a company's net profit divided,metric for estimating corporate value" target="_blank" rel="noreferrer">Learn More</a></p>
          </Text3>
        </Container>
      </Wrapper>
    );
  }

}

export default NewMetricEPS;



// WEBPACK FOOTER //
// ./src/components/onboarding/what-to-expect/NewMetricEPS.js